import React from 'react';
import './Services.css';
import ServicesHeroSection from '../components/ServicesHeroSection';
import itIcon from '../assets/icons/nh-icon-it-con.png';
import cloudIcon from '../assets/icons/nh-icon-cloud.png';
import aiIcon from '../assets/icons/nh-icon-ai.png';
import digitalTransformationIcon from '../assets/icons/nh-icon-digital-transformation.png';
import outsourcingIcon from '../assets/icons/nh-icon-outsourcing.png';
import appDevIcon from '../assets/icons/nh-icon-app-dev.png';

function Services() {
  return (
    <div>
      <ServicesHeroSection />
      <section className="services-overview">
        {/* <h2>Our Services</h2> */}
        <div className="services-grid">
          <div className="service-card">
            <img src={itIcon} alt="IT Consulting" className="service-icon" />
            <h3>IT Consulting</h3>
            <p>Expert guidance to align your IT strategy with your business objectives and future-proof your operations.</p>
          </div>
          <div className="service-card">
            <img src={cloudIcon} alt="Cloud Modernization" className="service-icon" />
            <h3>Cloud Modernization</h3>
            <p>Seamless migration and optimization of AWS, Azure, or hybrid cloud environments for agility and scalability.</p>
          </div>
          <div className="service-card">
            <img src={aiIcon} alt="GenAI Implementation" className="service-icon" />
            <h3>GenAI Implementation</h3>
            <p>Leverage Generative AI to automate workflows, enhance decision-making, and improve customer experiences.</p>
          </div>
          <div className="service-card">
            <img src={digitalTransformationIcon} alt="Digital Transformation" className="service-icon" />
            <h3>Digital Transformation</h3>
            <p>End-to-end support to help businesses embrace new technologies and drive innovation.</p>
          </div>
          <div className="service-card">
            <img src={outsourcingIcon} alt="Talent Partnership" className="service-icon" />
            <h3>Talent Marketplace</h3>
            <p>Hire skilled IT professionals on demand to meet your project requirements and reduce operational costs.</p>
          </div>
          <div className="service-card">
            <img src={appDevIcon} alt="Application Development" className="service-icon" />
            <h3>Application Development</h3>
            <p>Custom software solutions built with modern technologies like React, Node.js, Python, and Java.</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;